import { render, staticRenderFns } from "./MeasurementStartPopup.vue?vue&type=template&id=225228a6"
import script from "./MeasurementStartPopup.vue?vue&type=script&lang=ts"
export * from "./MeasurementStartPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports